import React from "react";
import { FormControl } from "@mui/material";
import {
  RichTextEditorComponent,
  Inject,
  HtmlEditor,
  Toolbar,
  Image,
  Link,
  QuickToolbar,
  Table
} from "@syncfusion/ej2-react-richtexteditor";
import config from "config";
import { EDITOR_IMAGE_BASE_DIRECTORY } from "app/utils/constant";


const RichTextEditorField = ({ value, onChange, height }) => {
  const transformDescriptionForEditor = (desc) => {
    if (!desc) return desc;
    const regex = new RegExp(`src="${EDITOR_IMAGE_BASE_DIRECTORY}/([^"]+)"`, "g");
    const url = desc.replace(
      regex,
      `src="${config.IMGIX_BASE_URL}/${EDITOR_IMAGE_BASE_DIRECTORY}/$1?w=800&auto=format"`
    );
    return url;
  };

  return (
    <FormControl fullWidth margin="normal">
      <RichTextEditorComponent
        id="defaultRTE"
        value={transformDescriptionForEditor(value)}
        change={(e) => onChange(e.value)}
        height={height}
        toolbarSettings={{
          items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
            'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
            'LowerCase', 'UpperCase', '|',
            'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
            'Outdent', 'Indent', 'Blockquote', '|',
            'CreateTable', 'CreateLink', 'Image', '|', 'ClearFormat',
            'SourceCode', 'FullScreen', '|', 'Undo', 'Redo', '|'
          ]
        }}
        insertImageSettings={{
          saveFormat: "Blob",
          allowedTypes: [".jpeg", ".jpg", ".png"],
          display: "inline",
          saveUrl: null
        }}
      >
        <Inject services={[Toolbar, Image, Link, HtmlEditor, QuickToolbar, Table
        ]} />
      </RichTextEditorComponent>
    </FormControl>
  );
};

export default RichTextEditorField;
